<template>
<div class="conteudo-sistema">

	<div class="fl-cabecalho">
		<div class="row animated slideInDown">
			<div class="col-6">
				<h4><fa-icon icon="sync-alt" /> Atualizações de manuais</h4>
			</div>
			<div class="col-6">
			</div>
		</div>
	</div>

	<hr />

    <div class="row animated slideInDown">
		<div class="col-sm-4 form-group">
			<label>Fabricante:</label>
			<select v-model="form.idFabricante" @change="form.idModelo = ''; buscou = false"
					class="form-control form-control-sm">
				<option value="">ESCOLHA</option>
				<option v-for="fabricante in fabricantes" :key="fabricante.id" :value="fabricante.id"> {{fabricante.descricao}}</option>
			</select>
		</div>
		<div class="col-sm-4 form-group">
			<label>Modelo:</label>
			<select v-model="form.idModelo" @change="buscou = false"
					class="form-control form-control-sm">
				<option value="">ESCOLHA</option>
				<option v-for="modelo in modelosFiltrados" :key="modelo.id" :value="modelo.id">{{modelo.descricao}}</option>
			</select>
		</div>

		<div class="col-sm-2 form-group">
			<label style="color:#F0F0F0">Fabricante:</label>
			<button :disabled="form.idModelo == '' || form.idFabricante == ''"
					@click="carregarModelo()"
					class="btn btn-sm btn-block btn-success">
				<fa-icon icon="sync-alt"/> CARREGAR
			</button>
		</div>

	</div>


	<div class="card-categoria animated fadeIn" v-for="(categoria, indexCategoria) in categorias" :key="indexCategoria">
        <app-section-title-container sectionTitleClass="section-title-contianer__title-container">
            <app-section-title
                :open="categoria._exibeCategoria"
                @click="carregarCategorias(categoria, indexCategoria)"
                :title="`${categoria.sigla} - ${categoria.categoria} - ${categoria.revisao}`"
            >
                <span v-if="categoria.dataAtualizacao != '0001-01-01T00:00:00'" v-tooltip="$filters.formatDate(categoria.dataAtualizacao)">
                    <fa-icon icon="info-circle"/>
                </span>
            </app-section-title>
        </app-section-title-container>

		<div class="animated fadeIn slow" v-if="categoria._exibeCategoria">

			<hr class="divisor-categoria">
			<div style="padding-subsessao">
				<div class="row" v-if="categoria._carregandoCategoria" style="margin-top:20px" >
					<div class="col-xs-12">
						<flCarregando />
					</div>
				</div>

				<div class="row" style="margin-top:10px">
					<div class="col-12 col-md-8 form-group">
						<button type="button"
								v-if="categoria.atualizacao != null"
								@click="clickCapitulo(categoria, null)"
								class="btn btn-outline-info btn-sm">
								<fa-icon icon="plus"/> Novo Capítulo
						</button>
					</div>

					<div class="col-12 col-md-4 form-group">
						<flFind
                            @key-up="(inputText) => buscarCategorias(categoria, inputText)"
							placeholder="Buscar"
                        />
					</div>
				</div>

				<div v-for="(atualizacao, indexAtualizacao) in categoria.atualizacoes" :key="indexAtualizacao" class="card-capitulos">
					<app-section-title-container>
                        <app-section-title
                            class="historico__titulo"
                            :open="atualizacao._exibeAtualizacao"
                            @click="carregarHistorico(categoria.id, atualizacao)"
                            :title="`${ atualizacao.id } -${ atualizacao.descricao } - Status: ${ atualizacao.status } - Data: ${ $filters.formatDate(atualizacao.dataCadastro, formatoDataHora) }`"
                        >
                        </app-section-title>
					</app-section-title-container>
					<div class="row" v-if="atualizacao._exibeAtualizacao">
						<div class="col-md-12">
							<hr style="border-bottom: 1px solid #DDD; margin-top:8px; margin-bottom:0px">
						</div>
					</div>
					<div class="animated fadeIn slow" v-if="atualizacao._exibeAtualizacao">
						<div v-if="atualizacao._carregandoHistorico">
							<div class="col-xs-12" style="margin-top:8px; margin-bottom:8px">
								<flCarregando />
							</div>
						</div>

						<div :style="{ 'max-height' : _height - 100 + 'px'}" class="box-inspecao" v-if="atualizacao.historicos.length > 0">
							<div :style="{'background' : getBk(historico)}" class="card-inspecao" v-for="(historico, indexHistorico) in atualizacao.historicos" :key="indexHistorico">
                                <app-section-title-container>
                                    <app-section-title
                                        :open="historico._exibeHistorico"
                                        @click="carregarStatus(historico, indexHistorico)"
                                        :title="`Histórico: ${ historico.id } - Data de envio: ${ $filters.formatDate(historico.dataEnvio, formatoDataHora) } - (Processamento autorizado: ${ historico.processamentoAutorizado ? 'Sim' : 'Não' }) - Cliente ${historico.idCliente}`"
                                    >
                                    </app-section-title>
                                </app-section-title-container>
                                <div class="row" v-if="historico._exibeHistorico">
                                    <div class="col-md-12">
                                        <hr style="border-bottom: 1px solid #DDD; margin-top:8px; margin-bottom:0px">
                                    </div>
                                    <div class="animated fadeIn slow">
                                        <div v-if="historico._carregandoStatus">
                                            <div class="col-xs-12" style="margin-top:8px; margin-bottom:8px">
                                                <flCarregando />
                                            </div>
                                        </div>
                                        <div v-if="!historico._carregandoStatus && !!historico.status.length">
                                            <div class="col-md-12" v-for="(status, indexStatus) in historico.status" :key="indexStatus">
                                                <app-section-title
                                                    class="card-capitulos"
                                                    :title="`Status: ${status.status}`"
                                                >
                                                </app-section-title>
                                            </div>
                                        </div>
                                        <div v-if="!historico._carregandoStatus && !historico.status.length">
                                            <p class="container text-info">
                                                <fa-icon icon="info-circle"/> Não foram encontrados status para esse histórico
                                            </p>
                                            <br>
                                        </div>
                                    </div> <!-- status -->
                                </div>
							</div>
						</div>

					</div><!-- historicos -->
				</div><!-- atualizacoes -->
			</div><!-- subsessao -->
		</div><!-- categoria -->
	</div><!-- categorias -->
</div>
</template>

<script>
import sectionTitleContainer from './components/sectionTitle/sectionTitleContainer.vue'
import sectionTitle from './components/sectionTitle/sectionTitle.vue'
import flModal from '../../../components/modal/main.vue'
import flCarregando from '../../../components/carregando/main.vue'
import _ from 'lodash'
import axios from '../../../routers/axios'
import flFind from '../../../components/find/main.vue'

export default {
	components: {
        'app-section-title': sectionTitle,
        'app-section-title-container': sectionTitleContainer,
		flModal,
		flCarregando,
		flFind
	},

	data() {
		return {
			fabricantes: [],
			modelos: [],
			load: true,
			buscou: false,
			atualizacoes: [],
			categorias: [],
			agrupamentos: [],
			servidoresEnvio: [],
			formatoDataHora: 'HH:mm DD/MM/YYYY',
			form: {
				idFabricante: "",
				idModelo: "",
				tipo: ""
			}
		};
	},

	mounted() {
		this.carregarDados();
	},

	computed: {
		modelosFiltrados() {
			return _.filter(this.modelos, m => { return this.form.idFabricante == m.idFabricante })
        },
	},

	methods: {
       getBk(item) {
			if (item.excluir == 1) {
				return "#FFCDD2";
			}

			if (item.inserir == 1) {
				return "#C8E6C9";
			}

			if (item.atualizar == 1) {
				return "#BBDEFB";
			}

			return "#FFF";
		},
		buscarCategorias(categoria, text) {
			if(text != '') {
				categoria._capitulos = _.filter(categoria.capitulos, capitulo => {
					let descricao =  capitulo.descricao + ''.toLowerCase()
					let nome =  capitulo.nome + ''.toLowerCase()
					let busca = text.toUpperCase()
					return descricao.indexOf(busca) > -1 ? true : nome.indexOf(busca) > -1
				})
			} else {
				categoria._capitulos = categoria.capitulos
			}
			this.$forceUpdate()
		},
		carregarDados() {
			this.load = true;
			axios.get(this._getUrl("api/fabricante")).then(response => {
				this.fabricantes = response.data;

				axios.get(this._getUrl("api/modelo")).then(response => {
					this.load = false;
					this.modelos = response.data.map(item => {
						item.fabricante = _.find(this.fabricantes, o => {
							return o.id == item.idFabricante;
						});
						item.descricaoFabricante = item.fabricante.descricao;
						return item;
					});
				});
			});

			axios.get(this._getUrl("api/ServidorEnvio")).then(response => {
				this.servidoresEnvio = response.data;
			})
		},
		carregarModelo() {
			this.$notify.loadIn('Carregando');
			axios.get(this._getUrl("api/atualizacaoManutencao")).then(rr => {
				if (_.isArray(rr.data)) {
					this.atualizacoes = rr.data;
				}
				axios.get(this._getUrl(`api/configinspecaomodelo/${this.form.idModelo}`)).then(response => {
					this.buscou = true
					if (_.isArray(response.data)) {
						this.categorias = response.data.map(item => {
							item._atualizacao = null;
							item._exibeCategoria = false;
							item._carregandoCategoria = false;
							item.atualizacoes = [];
							return item;
						});
					}
				});
			});
		},
		carregarCategorias(categoria, index) {
			if (!categoria._exibeCategoria) {
				categoria._exibeCategoria = true;
				if (categoria.atualizacoes.length == 0) {
					categoria._carregandoCategoria = true;
                    axios.get(this._getUrl(`api/atualizacaoManutencao/${categoria.id}/${this.form.idModelo}`))
                        .then((response) => {
                            if (_.isArray(response.data)) {
                                categoria.atualizacoes = response.data.map((atualizacao) => {
                                    atualizacao._exibeAtualizacao = false;
                                    atualizacao._carregandoHistorico = false;
                                    atualizacao.historicos = [];
                                    return atualizacao;
                                });
                            }
                            categoria._carregandoCategoria = false;
					    });
				}
			} else {
				categoria._exibeCategoria = false;
			}
		},
		carregarHistorico(categoriaId, atualizacao) {
			if (atualizacao._exibeAtualizacao == false) {
				atualizacao._exibeAtualizacao = true;
				if (atualizacao.historicos.length == 0) {
					atualizacao._carregandoHistorico = true;
                    axios.get(this._getUrl(`api/atualizacaoManutencaoHistorico/${atualizacao.id}`))
                        .then((response )=> {
                            if (_.isArray(response.data)) {
                                atualizacao.historicos = response.data.map((historico) => {
                                    historico._exibeHistorico = false;
                                    historico._carregandoStatus = false;
                                    historico.status = [];
                                    return historico;
							});
                            } else {
                                atualizacao.historicos = []
                            }
                            atualizacao._carregandoHistorico = false;
					    });
				}
			} else {
				atualizacao._exibeAtualizacao = false;
			}
        },
        carregarStatus(historico) {
			if (historico._exibeHistorico == false) {
				historico._exibeHistorico = true;
				if (historico.status.length == 0) {
					historico._carregandoStatus = true;
                    axios.get(this._getUrl(`api/statusAtualizacaoManutencao/${historico.id}`))
                        .then((response )=> {
                            if (_.isArray(response.data)) {
                                historico.status = response.data
                            } else {
                                historico.status = []
                            }
                            historico._carregandoStatus = false;
					    });
				}
			} else {
				historico._exibeHistorico = false;
			}
		},
	}
};
</script>

<style>
.card-manutencao {
	cursor:pointer;
	float:right;
	padding:0.55em 0.7em;
	font-size:0.7rem;
	margin-left:6px;
	border-radius:4px;
}

.box-inspecao {
	overflow-y: auto;
	margin-bottom:20px;
	overflow-x: hidden;
}

.btn-categoria {
	margin-left: 6px;
	margin-bottom: 6px
}

.card-categoria {
	border: 1px solid #DDD;
	padding: 8px;
	background: #FFF;
}

.card-capitulos {
	background:#F0F0F0;
	padding:4px 8px;
	border-radius:4px;
	margin-bottom:4px
}

.card-inspecao {
	margin-top:10px;
	padding-left: 10px;
	padding-top:10px;
	padding-right:10px;
	border-radius:8px
}
.divisor-categoria {
    border-bottom: 1px solid #DDD;
    margin-top:0px;
    margin-bottom:0px;
}
.padding-subsessao {
    padding-left: 20px;
}
.historico__titulo {
    margin-top: 10px;
    margin-bottom: -1rem;
    display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/followair/atualizacao-manual/main.vue